/* Comfy's: selection guard. A sold-out variant can never become the selected one: when a change would land on
   a sold-out combination, the options after the one just changed move to the closest purchasable variant. */
(function () {
  if (window.comfysVariantGuard) return;
  window.comfysVariantGuard = true;

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT' || input.type !== 'radio' || !input.dataset.inputId) return;

      var picker = input.closest('variant-picker');
      var mapElement = picker && picker.querySelector('script[data-comfys-availability]');
      if (!mapElement) return;

      var variants;
      try {
        variants = JSON.parse(mapElement.textContent);
      } catch (error) {
        return;
      }
      if (!variants.length) return;

      var count = variants[0].o.length;
      var changed = parseInt(input.dataset.inputId, 10) - 1;
      var radios = Array.prototype.slice.call(picker.querySelectorAll('fieldset input[type="radio"]'));
      var selection = [];

      radios.forEach(function (radio) {
        if (radio.checked && radio.dataset.inputId) selection[parseInt(radio.dataset.inputId, 10) - 1] = radio.value;
      });

      function matches(variant, upTo) {
        for (var i = 0; i < upTo; i++) {
          if (selection[i] !== undefined && variant.o[i] !== selection[i]) return false;
        }
        return true;
      }

      // The chosen combination is purchasable: nothing to correct.
      if (variants.some(function (variant) { return variant.a && matches(variant, count); })) return;

      // Otherwise keep the options up to the changed one and pick the closest purchasable variant.
      var best = null;
      var bestScore = -1;
      variants.forEach(function (variant) {
        if (!variant.a || !matches(variant, changed + 1)) return;
        var score = 0;
        for (var i = changed + 1; i < count; i++) {
          if (selection[i] !== undefined && variant.o[i] === selection[i]) score++;
        }
        if (score > bestScore) {
          best = variant;
          bestScore = score;
        }
      });
      if (!best) return;

      for (var i = changed + 1; i < count; i++) {
        var target = radios.filter(function (radio) {
          return radio.dataset.inputId && parseInt(radio.dataset.inputId, 10) - 1 === i && radio.value === best.o[i];
        })[0];
        if (target && !target.checked) {
          if (typeof picker.updateSelectedOption === 'function') picker.updateSelectedOption(target);
          else target.checked = true;
        }
      }

      input.dataset.variantId = String(best.id);
    },
    true
  );
})();
